// extracted by mini-css-extract-plugin
export default {"columnsMenu":"ColumnsControl_columnsMenu__8rxZE"};